import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import Programs from '../components/Programs';
import Coverage from '../components/Coverage';
import Projects from '../components/Projects';
import './ProgramsPage.css';

const ProgramsPage = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="programs-page">
      <div className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <h1 className="page-title">{t.programs}</h1>
            <p className="page-subtitle">
              {language === 'ar' 
                ? 'برامجنا الإنسانية والتنموية عبر السودان'
                : 'Our humanitarian and development programs across Sudan'}
            </p>
          </div>
        </div>
      </div>
      
      <Programs />
      <Coverage />
      <Projects />
    </div>
  );
};

export default ProgramsPage;
